export enum APPOINTMENT_REQUEST_STATUS {
  NEW = 'N',
  PATIENT_CONTACTED = 'A',
  PENDING = 'P',
  COMPLETED = 'D',
  CANCELLED = 'C',
  // INCOMPLETE = 'I',
  NO_RESPONSE = 'R',
}
